import orderHistoryReorderModel from 'account/orderHistory/orderHistoryReorder/orderHistoryReorderModel';
import orderHistoryAddProductsCollectData from 'account/orderHistory/orderHistoryAddProducts/orderHistoryAddProductsCollectData';
import ModalManager from 'global/modal/ModalManager';
import { getNodeFromString } from 'global/common/globalUtils';
import { GtmTrackingType } from 'global/constants';

class OrderHistoryReorderCreateReorder {
	constructor(validator) {
		this.validator = validator;
		const reorderDiv = document.querySelector(
			'[data-id="orderHistoryAddProducts"]',
		);
		const addToCartBtn = document.querySelector('[data-id="addToCartBtn"]');

		if (reorderDiv && addToCartBtn) {
			this.prepareSubmitUrl();
			addToCartBtn.addEventListener('click', this.handleReorder.bind(this));
		}
	}

	prepareSubmitUrl() {
		const urlContainingNode = document.querySelector(
			'[data-add-products-action-url]',
		);
		if (urlContainingNode) {
			this.submitUrl = urlContainingNode.getAttribute(
				'data-add-products-action-url',
			);
		}
	}

	async handleReorder() {
		const products = document.querySelectorAll(
			'[data-product-row-add-product]',
		);
		const reorderData = orderHistoryAddProductsCollectData(products);
		if (this.validator.validateForm(reorderData)) {
			const res = await this.sendReorderData(reorderData);
			this.updateMiniCart();
			this.handleResponse(res);
		}
	}

	sendReorderData(data) {
		if (!this.submitUrl) {
			this.prepareSubmitUrl();
		}

		if (this.submitUrl) {
			return orderHistoryReorderModel(JSON.stringify(data), this.submitUrl);
		}
		return Promise.reject(new Error('Could not find reorder submit URL'));
	}

	updateMiniCart() {
		document.dispatchEvent(new CustomEvent('cartUpdated'));
	}

	handleResponse(res) {
		if (res.status === 200) {
			if (!this.modalManager) {
				this.modalManager = new ModalManager();
			}
			this.modalManager.insertResponse(res.data, 'addToCartReorderModal');
			window.od.events.publish(
				GtmTrackingType.REORDER_ADD_TO_BASKET,
				this.getSignalData(res.data),
			);
		} else {
			throw new Error('Invalid response');
		}
	}

	getSignalData(responseHtml) {
		const signalDiv =
			getNodeFromString(responseHtml).querySelector('[data-signal]');

		try {
			return JSON.parse(signalDiv ? signalDiv.textContent : '{}');
		} catch (jsonError) {
			return {};
		}
	}
}

export default OrderHistoryReorderCreateReorder;
